import OrderModal from "@/models/Order";
import VisaModal from "@/models/Visa";

const GET_ORDER_DETAIL = 'GET_ORDER_DETAIL';
const GET_ORDER_PAY_INFO = 'GET_ORDER_PAY_INFO';
const CANCEL_ORDER_DETAIL = 'CANCEL_ORDER_DETAIL';
const CANCEL_REFUND_DETAIL = 'CANCEL_REFUND_DETAIL';
const UPDATE_VISA_ORDER_BASE_INFO = 'UPDATE_VISA_ORDER_BASE_INFO';
const FILL_EXPRESS_INFO = 'FILL_EXPRESS_INFO';
const CLAER_ORDER_DETAIL_INFO = 'CLAER_ORDER_DETAIL_INFO';

/**
 * 获取订单详情
 * @param {Object} params {
 *    @param {string} tradeCode 订单编号(查订单详情时传入)
 *    @param {string} refundCode 退单编号(查退单详情时传入)
 * }
 */
async function getOrderDetail(params) {
  const payload = await new OrderModal().orderDetail(params);
  return {
    type: GET_ORDER_DETAIL,
    payload
  }
}

/**
 * 根据订单编号获取支付信息
 * @param {string} tradeCode 订单编号
 */
async function getOrderPayInfo(tradeCode) {
  const payload = await new OrderModal().getPayInfo(tradeCode);
  return {
    type: GET_ORDER_PAY_INFO,
    payload
  }
}

/**
 * 取消订单
 * @param {string} tradeCode 订单编号
 */
async function cancelOrderDetail(tradeCode) {
  const payload = await new OrderModal().cancelOrder(tradeCode);
  return {
    type: CANCEL_ORDER_DETAIL,
    payload
  }
}

/**
 * 取消退单
 * @param {string} refundCode 退单编号
 */
async function cancelRefundDetail(refundCode) {
  await new OrderModal().cancelRefundOrder(refundCode);
  return {
    type: CANCEL_REFUND_DETAIL,
    payload: {
      refundCode
    }
  }
}

/**
 * 更新签证订单基础信息
 */
async function uploadVisaOrderBaseInfo(params) {
  const payload = await new VisaModal().uploadVisaOrderBaseInfo(params);
  return {
    type: UPDATE_VISA_ORDER_BASE_INFO,
    payload
  }
}

/**
 * 填写寄送快递单号
 */
async function fillExpressInfo(params) {
  const payload = await new VisaModal().fillExpressInfo(params);
  return {
    type: FILL_EXPRESS_INFO,
    payload
  }
}

/**
 * 清除订单详情页信息
 */
async function clearOrderDetailInfo() {
  return {
    type: CLAER_ORDER_DETAIL_INFO
  }
}

const ACTION_TYPES = {
  GET_ORDER_DETAIL,
  GET_ORDER_PAY_INFO,
  CANCEL_ORDER_DETAIL,
  CANCEL_REFUND_DETAIL,
  UPDATE_VISA_ORDER_BASE_INFO,
  FILL_EXPRESS_INFO,
  CLAER_ORDER_DETAIL_INFO,
};

const ACTION = {
  getOrderDetail,
  getOrderPayInfo,
  cancelOrderDetail,
  cancelRefundDetail,
  uploadVisaOrderBaseInfo,
  fillExpressInfo,
  clearOrderDetailInfo,
};

const OrderDetail = {
  ACTION_TYPES,
  ACTION
}

export default OrderDetail;